// "Frequently bought together" in the cart drawer. The markup is re-rendered
// with the drawer on every cart change, so listeners are delegated from document.
(() => {
  if (window.ccgCartUpsellInit) return;
  window.ccgCartUpsellInit = true;

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-upsell-variant]');
    if (!select) return;
    const item = select.closest('.cart-upsell__item');
    const option = select.selectedOptions[0];
    item.querySelector('[data-upsell-add]').dataset.variantId = option.value;
    const price = item.querySelector('[data-upsell-price]');
    price.innerHTML = (option.dataset.compare ? `<s>${option.dataset.compare}</s>` : '') + `<span>${option.dataset.price}</span>`;
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-upsell-add]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();

    const item = button.closest('.cart-upsell__item');
    const error = item.querySelector('.cart-upsell__error');
    // On the cart page the upsell sits in the page itself, so reload it there
    // instead of refreshing the (closed) drawer.
    const onCartPage = !!document.querySelector('cart-items:not(cart-drawer-items)');
    const cartDrawer = onCartPage ? null : document.querySelector('cart-drawer');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    error.hidden = true;

    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: Number(button.dataset.quantity) || 1 }],
          sections: cartDrawer ? cartDrawer.getSectionsToRender().map((s) => s.id) : [],
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not add to cart');

      if (cartDrawer) {
        cartDrawer.renderContents(state);
      } else if (onCartPage) {
        window.location.reload();
      } else {
        window.location.href = window.routes.cart_url;
      }
    } catch (e) {
      error.textContent = e.message;
      error.hidden = false;
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  });
})();
